// ============================================
// UI - Spinner Component
// ============================================

import React from 'react';
import { cn } from '../lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className }) => {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className="flex items-center justify-center">
      
      <svg
        className={cn('animate-spin', sizes[size], className)}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="#E5E7EB"
          strokeWidth="4"
        />
        <path
          stroke="#43BFFF"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
          d="M12 2a10 10 0 0 1 10 10"
        />
      </svg>
    </div>
  );
};
